import { ReduxService } from 'dashboard-services/services';

import { ftlEditorActions } from 'actions/modules/tools';

export const ftlEditorInitialState = {
  disabled: false,
  open: false,
  fileId: undefined,
  provider: undefined
}

export default (state = ftlEditorInitialState, action) => {

  switch (action.type) {
    case ftlEditorActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}